import xor from 'lodash/xor'
import shuffle from 'lodash/shuffle'
import FuzzySet from 'fuzzyset.js'
import getNRandomElements from 'random-n'
import { findBestMatch } from 'string-similarity'
import { uniqueWords as getWords } from 'truly-unique'

// TODO matching similar sentences could be better
const findSimilarSentences = (text, sentences, minRating = 0.2) => (
  findBestMatch(text, sentences)
    .ratings
    .filter((item) => item.rating >= minRating)
    .map((item) => item.target)
)

const createRandomMessage = (sentences, length = 1) =>
  getNRandomElements(sentences, length).join(' ').trim()

const replaceOneByOne = (string, pattern, replacer, _i = 0) => (
  (!string || !string.match(pattern))
    ? string
    : replaceOneByOne(string.replace(pattern, replacer(_i)), pattern, replacer, _i + 1)
)

const MessageGenerator = ({
  adjectives: {
    searchValues = [],
    replaceValues = []
  },
  outputSentences = [],
}) => (text = '') => new Promise((resolve) => {
  // eslint-disable-next-line
  const originalSentences = text ? (text.match(/[^\.!\?]+[\.!\?]+/g) || []) : []
  let usedOutputSentences = []

  const sentenceTemplate = originalSentences.reduce((template, sentence) => {
    const similarSentences = findSimilarSentences(sentence, xor(outputSentences, usedOutputSentences))
    const bestMatchSentence = createRandomMessage(similarSentences)

    if (!bestMatchSentence) {
      return template
    }

    usedOutputSentences = [...usedOutputSentences, bestMatchSentence]

    return [...template, bestMatchSentence]
  }, []).join(' ') || createRandomMessage(outputSentences)

  const searchValueSet = new FuzzySet(searchValues)
  const originalAdjectives = getWords(text || '').filter(token => !!searchValueSet.get(token, null, 0.55))
  const shuffledReplaceValues = shuffle(replaceValues)

  const replacePattern = new RegExp('{{ adjective }}')
  const compiledSentence = replaceOneByOne(sentenceTemplate, replacePattern, (i) => (
    [originalAdjectives[i], shuffledReplaceValues[i]].filter(v => !!v).join(' ')
  ))

  return resolve(compiledSentence)
})

export default MessageGenerator
